import React from 'react';
import Icon from '../../../components/AppIcon';

const IntegrationStatus = () => {
  const integrations = [
    {
      id: 1,
      name: "Lohnabrechnungssystem",
      status: "connected",
      lastSync: "vor 5 Min.",
      icon: "DollarSign"
    },
    {
      id: 2,
      name: "Zeiterfassung",
      status: "connected",
      lastSync: "vor 2 Min.",
      icon: "Clock"
    },
    {
      id: 3,
      name: "Google Kalender",
      status: "warning",
      lastSync: "vor 1 Std.",
      icon: "Calendar"
    }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'connected':
        return 'text-success';
      case 'warning':
        return 'text-warning';
      case 'error':
        return 'text-error';
      default:
        return 'text-muted-foreground';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'connected':
        return 'CheckCircle';
      case 'warning':
        return 'AlertTriangle';
      case 'error':
        return 'XCircle';
      default:
        return 'Circle';
    }
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-foreground mb-4">Integration Status</h3>
      <div className="space-y-3">
        {integrations?.map((integration) => (
          <div key={integration?.id} className="bg-card border border-border rounded-lg p-3 shadow-card">
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center space-x-2">
                <Icon name={integration?.icon} size={16} className="text-muted-foreground" />
                <span className="text-sm font-medium text-foreground">{integration?.name}</span>
              </div>
              <Icon 
                name={getStatusIcon(integration?.status)} 
                size={16} 
                className={getStatusColor(integration?.status)} 
              />
            </div>
            <p className="text-xs text-muted-foreground">
              Letzte Synchronisation: {integration?.lastSync}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IntegrationStatus;